import React, { Fragment, useContext, useState, useRef } from "react";
import {
  Table,
  Form,
  Button,
  Label,
  Input,
  FormGroup,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import { Dispatch } from "../store/store";
import { Type, CommissionType, getStatusName } from "../../../../utils/Order/Order";
import { showToast, toDateLocal, UserType } from "../../../../utils/Helper";
import style from "./Basket.module.scss";
import Edit from "./Edit";
import Order from "../Order";
import { orderReducer } from "../store/reducer";
import { useEffect } from "react";
import Numeric from "../Field/Numeric";
import translate from "../../../../utils/Translator";

const Basket = ({
  canAddAccount,
  removeAccount,
  searchAccount,
  accountHolders,
  accountInfo,
  account,
  accounts,
  onChange,
  isReadOnly,
  canModifyComposition,
  readonly,
  balanceReady,
  error,
  hiddens,
  toggleOrderModal,
}) => {
  const nextAccountIndex = accounts ? accounts.length : 0;

  const [edit, setEdit] = useState({
    open: account.index >= 0,
  });

  const [offerAdvisors, setOfferAdvisors] = useState(0);
  const [offerClients, setOfferClients] = useState(0);
  const [offerFeatured, setOfferFeatured] = useState(false);

  const [validSubAssetClasses, setValidSubAssetClasses] = useState([]);
  const [errorMessages, setErrorMessages] = useState([]);
  const [statusUpload, setStatusUpload] = useState("PendingUpload");
  const fileInputRef = useRef(null);

  const [open, setOpen] = useState(false);

  const iconsUploadXLSX = {
    PendingUpload: "fa fa-upload",
    UploadFailed: "fa fa-exclamation-triangle",
    Processing: "fa fa-cog fa-spin",
    Processed: "fa fa-check",
  };

  const buttonMessageUpload = {
    PendingUpload: "Upload XLSX",
    UploadFailed: "Failed. Try Again",
    Processing: "Processing...",
    Processed: "Uploaded",
  };

  const { dispatch, state, services } = useContext(Dispatch);
  const { ui, order } = state;

  const toggleErrorModal = () => {
    if (toggleOrderModal) {
      setOpen(!open);
      toggleOrderModal(order.OrderId);
    }
  };

  const getStatus = () => {
    return order.isChecked;
  };

  const loadOffer = () => {
    dispatch({ type: "CHANGE_ORDER_FIELDS", fields: { offerGetted: true, isChecked: false } });
    if (order.OrderId || (order.offer ? order.offer.OrderId : "")) {
      let id = order.OrderId ? order.OrderId : order.offer.OrderId;
      if (typeof services.account.getOffer === "function") {
        services.account.getOffer({ orderId: id }).then((resp) => {
          if (
            resp &&
            resp.response.Offer &&
            (resp.response.Offer.OfferQuantitytoAdvisor != 0 ||
              resp.response.Offer.OfferQuantitytoClient != 0)
          ) {
            let offerM = {
              disabled: resp.response.Offer.disabled,
              OfferQuantitytoAdvisor: (
                Math.round(resp.response.Offer.OfferQuantitytoAdvisor * 100) / 100
              ).toFixed(2),
              OfferQuantitytoClient: (
                Math.round(resp.response.Offer.OfferQuantitytoClient * 100) / 100
              ).toFixed(2),
              OfferPrice: resp.response.Offer.OfferPrice,
              OfferId: resp.response.Offer.OfferId,
              featured: resp.response.Offer.featured,
            };
            dispatch({
              type: "CHANGE_ORDER_FIELDS",
              fields: { offer: offerM, offerLoaded: resp.response.Offer, isChecked: !offerM.disabled },
            });
            setOfferAdvisors(offerM.OfferQuantitytoAdvisor);
            setOfferClients(offerM.OfferQuantitytoClient);
            setOfferFeatured(offerM.featured);
            offerM.disabled ? clearFields() : "";
          } else {
            if (!resp) {
              resp.response.Offer.OfferId
                ? dispatch({
                    type: "CHANGE_ORDER_FIELDS",
                    fields: { offerLoaded: resp.response.Offer },
                  })
                : "";
            }
          }
        });
      }
    }
  };

  useEffect(() => {
    dispatch({ type: "CHANGE_ORDER_FIELDS", fields: { offer: { disabled: true } } });
    loadOffer();
  }, []);

  useEffect(() => {
    if (!order.OrderIsBasket) return;
    if (!services || !services.account || !services.account.getParameterValue) return;

    services.account.getParameterValue &&
      services.account.getParameterValue({ ParameterName: "AutomationBasketSubAC" }).then((res) => {
        if (!res || !res.SdtParametersData) return;
        const { SdtParametersData } = res;
        const { ParameterCharacterValueLong } = SdtParametersData || {};
        const subAssetClassesValidForAutomaticBasket = ParameterCharacterValueLong
          ? ParameterCharacterValueLong.split(",")
          : [];
        setValidSubAssetClasses(subAssetClassesValidForAutomaticBasket);
      });
  }, []);

  const onSelectAccount = (accountIndex = null) => {
    dispatch({
      type: "SELECT_ACCOUNT",
      props: {
        accountIndex,
      },
    });
  };

  const changeChecked = (state) => {
    dispatch({ type: "CHANGE_ORDER_FIELDS", fields: { isChecked: state } });
    if (!state) {
      clearFields();
      dispatch({ type: "CHANGE_ORDER_FIELDS", fields: { offer: { disabled: true } } });
    } else {
      if (order.offerLoaded) {
        let offerM = {
          ...order.offer,
          disabled: false,
          OfferQuantitytoAdvisor: (Math.round(order.offerLoaded.OfferQuantitytoAdvisor * 100) / 100).toFixed(
            2
          ),
          OfferQuantitytoClient: (Math.round(order.offerLoaded.OfferQuantitytoClient * 100) / 100).toFixed(2),
          OfferPrice: order.Price,
          OfferId: order.offerLoaded.OfferId,
          featured: order.offerLoaded.featured,
        };

        dispatch({ type: "CHANGE_ORDER_FIELDS", fields: { offer: offerM } });
        setOfferFeatured(offerM.featured);
        setOfferAdvisors((Math.round(order.offerLoaded.OfferQuantitytoAdvisor * 100) / 100).toFixed(2));
        setOfferClients((Math.round(order.offerLoaded.OfferQuantitytoClient * 100) / 100).toFixed(2));
      }
    }
  };

  const clearFields = () => {
    let offerM = {
      ...order.offer,
      OfferQuantitytoAdvisor: 0,
      OfferQuantitytoClient: 0,
      OfferPrice: order.Price,
      featured: false,
    };
    setOfferClients(0);
    setOfferAdvisors(0);
    setOfferFeatured(false);
    dispatch({ type: "CHANGE_ORDER_FIELDS", fields: { offer: offerM } });
  };
  const toggleEdit = (accountIndex = null, discard) => {
    if (!edit.open) {
      if (canAddAccount()) {
        setEdit({ open: true });
        onSelectAccount(accountIndex);
      }
    } else {
      if (discard) {
        dispatch({ type: "DELETE_ACCOUNT", accountIndex });
      }

      setEdit({ open: false });
    }
  };

  const onEditAccount = (account) => {
    dispatch({
      type: "EDIT_ACCOUNT",
      props: {
        type: Type.Basket,
        account,
      },
    });
  };

  const onDownloadFile = (accountId) => {
    const { downloadAttachment } = services.account;
    const orderId = order.OrderId;
    downloadAttachment({ orderId, accountId });
  };

  const onDownloadPt = (accountId) => {
    const { orderPdf } = services.account;
    const orderId = order.OrderId;
    orderPdf({
      orderId: orderId,
      accountId: accountId,
    });
  };

  const setOfferClientsF = (value) => {
    let offerM = {
      ...order.offer,
      OfferQuantitytoClient: value,
      OfferPrice: order.Price,
    };
    setOfferClients(value);
    dispatch({ type: "CHANGE_ORDER_FIELDS", fields: { offer: offerM } });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const isXlsx =
      file.name.toLowerCase().endsWith(".xlsx") ||
      file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    if (!isXlsx) {
      showToast("Format must be .xlsx", true);
      setStatusUpload("UploadFailed");
      e.target.value = "";
      return;
    }

    const maxSize = 100 * 1024 * 1024;
    if (file.size > maxSize) {
      showToast("Max Size 100 MB", true);
      setStatusUpload("UploadFailed");
      e.target.value = "";
      return;
    }
    processOrdersFile(file);
  };

  const processOrdersFile = (file) => {
    if (!services.account.getAccountsFromXLSX) return;

    const formData = new FormData();

    formData.append("file", file);
    formData.append("orderId", order.OrderId);

    setStatusUpload("Processing");
    services.account
      .getAccountsFromXLSX(formData)
      .then((res) => {
        const { response } = res;
        if (response && response.errorMessages && response.errorMessages.length == 0) {
          if (toggleOrderModal) {
            toggleOrderModal(order.OrderId);
          }
        } else {
          setOpen(true);
          setErrorMessages(response.errorMessages);
        }

        setStatusUpload("Processed");
        showToast(`File ${file.name} uploaded.`);
      })
      .catch(() => setStatusUpload("UploadFailed"));
  };

  const editOffer = (name, value) => {
    let offerM = {
      ...order.offer,
      [name]: value,
    };
    setOfferFeatured(value);
    dispatch({ type: "CHANGE_ORDER_FIELDS", fields: { offer: offerM } });
  };

  const setOfferAdvisorsF = (value) => {
    let offerM = {
      ...order.offer,
      OfferQuantitytoAdvisor: value,
      OfferPrice: order.Price,
    };
    setOfferAdvisors(value);
    dispatch({ type: "CHANGE_ORDER_FIELDS", fields: { offer: offerM } });
  };

  const onDeleteAccount = (accountIndex, accountId) => {
    if (window.confirm(`Are you sure to remove the ${translate("Account")}?`)) {
      if (order.OrderId > 0) {
        removeAccount({
          orderId: order.OrderId,
          accountId,
        }).then((res) => {
          dispatch({ type: "DELETE_ACCOUNT", accountIndex });
        });
      } else {
        dispatch({ type: "DELETE_ACCOUNT", accountIndex });
      }
    }
  };

  const { downloadAttachment, orderPdf } = services.account;

  const editProps = {
    toggle: toggleEdit,
    accountProps: {
      searchAccount,
      accountHolders,
      accountInfo,
      downloadAttachment,
    },
  };

  const isAutomaticBasket = validSubAssetClasses.includes(order.AssetSubAssetClassId);

  return (
    <div style={{}}>
      <span className={style.title}>{translate("Account")}s</span>
      {edit.open ? (
        <Edit
          {...editProps}
          userType={ui.userRole}
          account={
            order.CurrentAccount || {
              index: nextAccountIndex,
              CommissionType: CommissionType.PrincipalPercentage,
              MarkupType: CommissionType.FaceValueCash,
              Advice: false,
              FXMarkupType: CommissionType.FaceValueCash,
              CurrentInfoDate: toDateLocal(new Date()),
            }
          }
          onChange={onChange}
          onEdit={onEditAccount}
          dispatch={dispatch}
          parameters={ui.parameters}
          accounts={order.Accounts}
          hiddens={hiddens}
          readonly={readonly}
          isReadOnly={isReadOnly}
          order={order}
          balanceReady={balanceReady}
          orderPdf={orderPdf}
        />
      ) : (
        <Fragment>
          <Button
            color="primary"
            className={`${style.btnAdd} btn-sm mt-1`}
            onClick={() => toggleEdit()}
            disabled={!canModifyComposition}
          >
            <i className="fa fa-plus"></i>
            {"\u00A0"} Add {translate("Account")}
          </Button>
          {isAutomaticBasket && ui.userRole === UserType.Trader && (
            <React.Fragment>
              <Button
                color="primary"
                className={`${style.btnAdd} btn-sm mt-1 mr-2`}
                onClick={() => fileInputRef.current.click()}
                disabled={!canModifyComposition}
              >
                <i className={iconsUploadXLSX[statusUpload]}></i>
                {"\u00A0"} {buttonMessageUpload[statusUpload]}
              </Button>
              <input
                ref={fileInputRef}
                type="file"
                accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </React.Fragment>
          )}
          {errorMessages &&
            errorMessages.length > 0 &&
            isAutomaticBasket &&
            ui.userRole === UserType.Trader && (
              <Modal isOpen={open} toggle={toggleErrorModal} size="lg" scrollable>
                <ModalHeader toggle={toggleErrorModal}>There were imported accounts with errors:</ModalHeader>
                <ModalBody>
                  <ListGroup>
                    {errorMessages.map((err, i) => (
                      <ListGroupItem className="m-2" key={i}>
                        {err}
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={toggleErrorModal}>
                    Cerrar
                  </Button>
                </ModalFooter>
              </Modal>
            )}
          <div className={`${style.table} ${error ? style.error : ""}`}>
            <Table responsive striped>
              <thead>
                <tr>
                  <th>Quantity</th>
                  <th>{translate("Account")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {accounts.length == 0 && <EmptyAccounts />}
                {accounts.map((account, i) => {
                  const userIsOwner =
                    (ui.userRole == UserType.Trader && account.AccountType != "Customer") ||
                    (ui.userRole == UserType.Advisor && account.AccountType == "Customer");

                  return (
                    <AccountItem
                      key={`baccount-${i}`}
                      account={account}
                      readonly={!userIsOwner || !canModifyComposition}
                      onDelete={onDeleteAccount}
                      onEdit={() => toggleEdit(account.index)}
                      onDownloadPt={onDownloadPt}
                      disabledEdit={order.offer && !order.offer.disabled}
                      onDownloadFile={onDownloadFile}
                    />
                  );
                })}
              </tbody>
            </Table>
          </div>
          <div>
            <Form disabled={state.order.OrderSide == "Sell"}>
              {ui.userRole == "Trader" && (
                <div>
                  <Row>
                    <Col>
                      <Label check>Offer</Label>
                      <span> </span>
                      <Label
                        className="switch switch-text switch-pill switch-secondary switch-lg"
                        style={{ marginBottom: "0px" }}
                      >
                        <Input
                          type="checkbox"
                          className="switch-input"
                          onChange={(e) => changeChecked(e.target.checked)}
                          value={order.isChecked}
                          checked={order.isChecked}
                        />
                        <span className="switch-label" data-on="Yes" data-off="No"></span>
                        <span className="switch-handle"></span>
                      </Label>
                    </Col>
                    <Col>
                      <Label check>Featured</Label>
                      <span> </span>
                      <Label
                        className="switch switch-text switch-pill switch-secondary switch-lg"
                        style={{ marginBottom: "0px" }}
                      >
                        <Input
                          type="checkbox"
                          className="switch-input"
                          value={offerFeatured}
                          checked={offerFeatured}
                          disabled={
                            !order.isChecked || state.order.OrderSide == "Sell" || ui.userRole == "Advisor"
                          }
                          onChange={(e) => editOffer("featured", e.target.checked)}
                        />
                        <span className="switch-label" data-on="Yes" data-off="No"></span>
                        <span className="switch-handle"></span>
                      </Label>
                    </Col>
                  </Row>
                </div>
              )}
              <FormGroup>
                <Label for="offerAdvisors">Quantity Offer Advisors</Label>
                <Numeric
                  value={offerAdvisors}
                  placeholder={"Quantity"}
                  dataTypeDecimalName="quantity"
                  disabled={!order.isChecked || state.order.OrderSide == "Sell" || ui.userRole == "Advisor"}
                  onChange={setOfferAdvisorsF}
                  {...(state.order.OrderSide == "Sell" && offerAdvisors != "" ? setOfferAdvisorsF("") : "")}
                />
              </FormGroup>
              <FormGroup>
                <Label for="offerClients">Quantity Offer Clients</Label>
                <Numeric
                  placeholder="Quantity"
                  type="input"
                  dataTypeDecimalName="quantity"
                  disabled={!order.isChecked || state.order.OrderSide == "Sell" || ui.userRole == "Advisor"}
                  value={offerClients}
                  onChange={setOfferClientsF}
                  {...(state.order.OrderSide == "Sell" && offerClients != "" ? setOfferClientsF("") : "")}
                />
              </FormGroup>
            </Form>
          </div>
          {error && <div className={`invalid-feedback ${style.errorText}`}>{error}</div>}
        </Fragment>
      )}
    </div>
  );
};

const AccountItem = ({ account, readonly, onDelete, onDownloadPt, onEdit, disabledEdit, onDownloadFile }) => (
  <tr>
    <td>
      <FormattedNumber value={account.Quantity} dataTypeDecimalName="quantity" />
    </td>
    <td>{account.AccountNumber}</td>
    {account.AccountId > 0 && (
      <td>
        {account.AccountId > 0 && account.HasFile && (
          <Button
            color="btn-outline-primary btn-sm"
            disabled={account.HasFileUploadPending}
            onClick={() => onDownloadFile(account.AccountId)}
          >
            <i className="fa fa-download"></i>
          </Button>
        )}
        <Button
          color="btn-outline-primary btn-sm"
          onClick={() => onDownloadPt(account.AccountId)}
          disabled={false}
        >
          <i className="fa fa-file"></i>
        </Button>
        <Button color="btn-outline-primary btn-sm" onClick={() => onEdit()} disabled={disabledEdit}>
          <i className="fa fa-pencil"></i>
        </Button>
        <Button
          color="btn-outline-primary btn-sm"
          disabled={readonly}
          onClick={() => onDelete(account.index, account.AccountId)}
          style={{ color: "#d83737" }}
        >
          <i className="fa fa-trash"></i>
        </Button>
      </td>
    )}
  </tr>
);

const EmptyAccounts = () => (
  <tr className={style.empty}>
    <td colSpan="3">
      <h5 style={{ textAlign: "center" }}>No {translate("Account")}s</h5>
    </td>
  </tr>
);

export default Basket;
